import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import OuterHeader from '../Layout/OuterHeader'
import InnerHeader from '../Layout/InnerHeader'
import Dashboard from '../Dashboard'
import Footer from '../Layout/Footer'
import FAQCard from '../FAQ/FAQCard'
import { ADMIN_LAND_PAGE } from '../../routes'
import { connect } from 'react-redux'
import { updateQetafRewardPoints, emptyQetaf } from '../../Actions/QetafAction'
import propTypes from 'prop-types'

class UpdateQetafRewardPoints extends Component {
  state = {
    msisdn: '',
    internalReference: '',
    reductionAmount: '',
  }

  componentWillUnmount() {
    this.props.emptyQetaf()
  }

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })

  submitUpdate = (e) => {
    e.preventDefault()
    const { msisdn, internalReference, reductionAmount } = this.state
    if (!msisdn || !reductionAmount) {
      alert('Please enter MSISDN and Reduction Amount')
      return
    }
    this.props.updateQetafRewardPoints(
      msisdn ? Number(msisdn) : null,
      internalReference,
      reductionAmount ? Number(reductionAmount) : null
    )
  }

  render() {
    const { qetafState } = this.props
    const isLoading = qetafState && qetafState.updateRewardLoading
    const error = qetafState && qetafState.updateRewardError
    const result = qetafState && qetafState.updateRewardResponse

    return (
      <div className="container">
        <OuterHeader />
        <div className="container">
          <div className="container-body">
            <div className="row">
              <Dashboard />
              <div className="col-9">
                <InnerHeader />
                <div className="main-content">
                  <div className="row">
                    <div className="col-12 left-main-body" id="left-main-body">
                      <div className="box-container">

                        <div className="statusbar small-font">
                          <span className="status-link">
                            <Link to={ADMIN_LAND_PAGE}>Home</Link><span> &gt; </span>
                          </span>
                          <span>Update Qetaf Reward Points</span>
                        </div>

                        <div className="main-title-container">
                          <h5 className="main-title mt-2 font-weight-bold">Update Qetaf Reward Points</h5>
                        </div>

                        <form onSubmit={this.submitUpdate} className="p-3">
                          <div className="form-group">
                            <label>MSISDN <span className="text-danger">*</span></label>
                            <input 
                              name="msisdn" 
                              value={this.state.msisdn} 
                              onChange={this.handleChange} 
                              className="form-control"
                              required
                            />
                          </div>
                          <div className="form-group">
                            <label>Internal Reference (optional)</label>
                            <input 
                              name="internalReference" 
                              value={this.state.internalReference} 
                              onChange={this.handleChange} 
                              className="form-control"
                            />
                          </div>
                          <div className="form-group">
                            <label>Reduction Amount <span className="text-danger">*</span></label>
                            <input 
                              name="reductionAmount" 
                              value={this.state.reductionAmount} 
                              onChange={this.handleChange} 
                              className="form-control"
                              required
                            />
                          </div>
                          <button 
                            className="btn btn-primary" 
                            type="submit"
                            disabled={isLoading}
                          >
                            {isLoading ? 'Processing...' : 'Update Points'}
                          </button>
                        </form>

                        {isLoading && <div className="alert alert-info mt-3">Sending request...</div>}
                        {error && (
                          <div className="alert alert-danger mt-3">
                            <strong>Error:</strong> {typeof error === 'string' ? error : JSON.stringify(error)}
                          </div>
                        )}
                        {result && !isLoading && (
                          <div className="alert alert-success mt-3">
                            <strong>Success:</strong>
                            <pre>{JSON.stringify(result, null, 2)}</pre>
                          </div>
                        )}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  qetafState: state.qetaf,
})

UpdateQetafRewardPoints.propTypes = {
  updateQetafRewardPoints: propTypes.func.isRequired,
  emptyQetaf: propTypes.func.isRequired,
  qetafState: propTypes.object,
}

export default connect(mapStateToProps, { updateQetafRewardPoints, emptyQetaf })(UpdateQetafRewardPoints)
